module.exports = __webpack_public_path__ + "29f2ae05fd5de9bbf27898f9b500774a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Marquise@2x.png
// module id = 324
// module chunks = 0